import { createTrackerOptions } from '@/helpers/common';

export const VEHICLE_ALARM_IMMOBILISER = {
  N: 'None',
  M: 'Manufacturers Fitted',
  T1: 'Thatcham Сategory 1',
  T2: 'Thatcham Сategory 2',
  T3: 'Thatcham Сategory 3',
  O: 'Other Alarm/Immobiliser',
};

export const VEHICLE_TRACKING_DEVICE = {
  D: 'Datatag',
  A: 'Alphadot',
  S: 'Smartwater',
  O: 'Other',
  N: 'None',
};

export const VEHICLE_PHYSICAL_SECURITY = {
  N: 'None',
  BDL: 'Brake Disc Locks',
  CL: 'Cable Locks',
  DL: 'D Locks',
  PC: 'Padlock and Chain',
  O: 'Other',
};

export const VEHICLE_GREY_OR_IMPORT = {
  N: 'No',
  Y: 'European Import UK Spec',
  NU: 'European Import Non UK Spec',
  J: 'Japanese Import',
  U: 'US Import',
};

export const VEHICLE_IMMOBILISER = {
  Y: 'Manufacturer\'s Fitted',
  O: 'Other',
  N: 'No',
};

// Keys need confirmed with backend team for those listed as U1 - U6
export const VEHICLE_KEPT = {
  R: 'On the Road',
  D: 'On a Private Driveway',
  G: 'In a Locked Garage',
  CP: 'Car Park',
  LC: 'Locked Compound',
  PP: 'Kept on Private Property',
  C: 'Carport',
  UC: 'Unlocked Compound',
  SP: 'Secure Resident Parking',
  UP: 'Unsecure Resident Parking',
};
export const VEHICLE_KEPT_FAVORITES = ['R', 'D', 'G'];

export const VEHICLE_TYPE_OF_USE = {
  4: 'Social & commuting',
  5: 'Social only',
  1: 'Business Use (by the proposer)',
  7: 'Business Use (by the proposer & named riders)',
  9: 'Delivery Use',
};
export const VEHICLE_TYPE_OF_USE_BUSINESS = [1, 7, 9];
export const VEHICLE_TYPE_OF_USE_REQUIRED_DRIVERS = [7];

export const VEHICLE_TYPE_OF_USE_DESCRIPTION = {
  4: 'N.B. Social, Domestic, Pleasure and Commuting  to 1 place of work',
  5: 'N.B. Social, Domestic, Pleasure, excluding Commuting.',
  7: 'N.B. Also covers non-business use.',
  9: 'Cover for courier/delivery riding. This will not cover you for taxi purposes (Orivate/Public hire).Please check cover details with your chosen provider before purchasing.',
};

export const DRIVER_MARITAL_STATUS = {
  M: 'Married',
  S: 'Single',
  D: 'Divorced',
  W: 'Widowed',
  C: 'Common law',
  V: 'Civil partnership',
  T: 'Separated',
};
export const DRIVER_MARITAL_STATUS_FAVORITES = ['M', 'S', 'D', 'W'];

export const ADDITIONAL_RELATIONSHIP_PROPOSER = {
  S: 'Spouse',
  P: 'Parent',
  O: 'Son or Daughter',
  I: 'Brother or Sister',
  C: 'Common Law Spouse',
  V: 'Civil Partner',
  OF: 'Other family member',
  B: 'Business partner',
  EE: 'Employee',
  ER: 'Employer',
  N: 'None',
};
export const ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES = ['S', 'P', 'C', 'N'];

export const DRIVER_CHILDREN_MAX = 9;
export const DRIVER_CHILDREN_FAVORITES = [0, 1, 2, 3];
export const DRIVER_CHILDREN = (() => {
  const result = { 0: 'None' };
  [...Array(DRIVER_CHILDREN_MAX).keys()].forEach(n => {
    result[n + 1] = `${(n + 1).toString()} child`;
    if ((n + 1) > 1) result[n + 1] += 'ren';
  });
  return result;
})();
export const DRIVER_CHILDREN_MORE_LABEL = 'More';

export const DRIVER_RESIDENTIAL_STATUS = {
  HO: 'Home Owner',
  L: 'Living with Parents',
  HA: 'Housing Association',
  O: 'Other',
};

export const DRIVER_USE_OF_OTHER_VEHICLES = {
  X: 'No Access to Any Other Vehicles',
  N: 'Named Driver on Another Person\'s Policy',
  O: 'Owner of Another Van',
  M: 'Own/Use a Motorbike',
  V: 'Own/Use a Car',
  S: 'Company Car (Including Social Domestic and Pleasure Use)',
  C: 'Company Car (Within Working Hours)',
};

export const DRIVER_WHO_DRIVES_THE_VEHICLE = {
  IO: 'Yourself Only',
  IS: 'Yourself and your spouse',
  '02': 'Yourself and 1 other person',
  '03': 'Yourself and 2 other persons',
  '04': 'Yourself and 3 other persons',
};

export const DRIVER_EMPLOYMENT_STATUS = {
  E: 'Employed',
  F: 'Full-time education',
  S: 'Self Employed',
  R: 'Retired',
  U: 'Unemployed',
  D: 'Director',
  P: 'Proprietor or Partner',
  H: 'Houseperson',
  I: 'Independent Means',
  N: 'Not employed due to disability',
  G: 'Government',
  C: 'Club or Association',
};
export const DRIVER_EMPLOYMENT_STATUS_FAVORITES = ['E', 'S', 'F'];
export const DRIVER_EMPLOYMENT_STATUS_BUSINESS = ['E', 'S', 'D', 'P', 'G', 'C'];

export const SIXTEEN_TYPE_OF_DRIVING = ['M', 'P'];

export const DRIVER_TYPE_OF_DRIVING = {
  F: 'Full UK Motorcycle',
  M: 'Full UK Moped',
  P: 'Provisional UK Motorcycle',
  EEC: 'Full EU Motorcycle',
  PE: 'Provisional EU Motorcycle',
  I: 'Full International Motorcycle',
  PI: 'Provisional International Motorcycle',
  E: 'Other Euro Full Bike',
  PEO: 'Other Euro Provisional Bike',
};
export const DRIVER_TYPE_OF_DRIVING_FAVORITES = ['F', 'P', 'M'];
export const DRIVER_TYPE_OF_DRIVING_UK = ['F', 'P', 'M'];

export const DRIVER_CAR_TYPE_OF_DRIVING = {
  F: 'Full UK',
  P: 'Provisional UK',
  A: 'Automatic UK',
  E: 'EU Full',
  EP: 'EU Provisional',
  O: 'Other European',
  OI: 'Other International',
};
export const DRIVER_CAR_TYPE_OF_DRIVING_FAVORITES = ['F', 'P', 'A', 'EU'];

export const DRIVER_LICENCE_YEARS_HELD = {
  0: 'Less than 1 Year',
  1: '1 Year ',
  2: '2 Years ',
  3: '3 Years ',
  4: '4 Years ',
  5: '5 Years ',
  6: '6 Years ',
  7: '7 Years ',
  8: '8 Years ',
  9: '9 Years ',
  10: '10 Years ',
  11: '11 Years ',
  12: '12 Years',
  13: '13 Years',
  14: '14 Years',
  15: '15 Years',
  16: '16 Years',
  17: '17 Years',
  18: '18 Years',
  19: '19 Years',
  20: '20 Years or more',
};

export const DRIVER_LICENCE_MONTHS_HELD = {
  0: 'Less than 1 Month',
  1: '1 Month',
  2: '2 Months',
  3: '3 Months',
  4: '4 Months',
  5: '5 Months',
  6: '6 Months',
  7: '7 Months',
  8: '8 Months',
  9: '9 Months',
  10: '10 Months',
  11: '11 Months',
};

export const DRIVER_MEDICAL_CONDITIONS = {
  N: 'No',
  NR: 'DVLA Aware - No Restrictions',
  Y: 'DVLA - Restricted 1 Year',
  YY: 'DVLA - Restricted 2 Years',
  YYY: 'DVLA - Restricted 3 Years',
  DU: 'DVLA Unaware',
  DA: 'Doctor Advised Not To Drive',
};

export const DRIVER_CLAIM_CAUSE_INCIDENT_NO_CLAIM_MADE = 1;

export const DRIVER_CLAIM_CAUSE_OF_DESCRIPTION = {
  1: 'Incident - no claim made',
  2: 'Accident - not settled',
  3: 'Accident - not settled and persons injured',
  4: 'Accident - driver at fault, but no injuries',
  5: 'Accident - driver at fault with persons injured',
  6: 'Accident - driver not at fault and recovered all costs and excess',
  7: 'Accident - driver not at fault and full recovery, but persons injured',
  8: 'Accident - single vehicle',
  9: 'Storm or flood damage',
  10: 'Fire damage',
  11: 'Vandalism',
  12: 'Theft - vehicle from outside home, but was recovered',
  13: 'Theft - vehicle from outside home, was not recovered',
  14: 'Theft - vehicle parked away from home, but was recovered',
  15: 'Theft - vehicle parked away from home, was not recovered',
  16: 'Theft - vehicle contents stolen from outside home',
  17: 'Theft - vehicle contents stolen, was parked away from home',
  18: 'Windscreen/glass',
};
export const DRIVER_CONVICTION_ALCOHOL_LEVEL_REQUIRED_CODES = [
  'CD40',
  'CD60',
  'DR10',
  'DR20',
  'DR50',
  'DR40',
];

export const DRIVER_CONVICTION_ALCOHOL_METHOD_TEST = {
  B: 'Breath',
  L: 'Blood',
  U: 'Urine',
};

export const DRIVER_RIDING_QUALIFICATIONS = {
  N: 'No',
  IAM: 'Institute of Advanced Motorists (IAM) Motorcycle Test',
  APM: 'Advanced Police Motorcyclists',
  BS: 'Bike Safe',
  BBR: 'BMF Blue Riband',
  BCP: 'BMF Certificate of Proficiency',
  DCC: 'DSA Certificate Of Competence (Enhanced Rider Bonus)',
  DSA: 'Driving Standards Agency - Examiners Motorcycle test',
  RSP: 'Royal Society for Provention of Accidents (RoSPA)',
  E: 'The Edge ',
  VAR: 'Vision Advanced Rider Training Qualification',
};

export const DRIVER_MEMBER_BIKING_ORGANISATION = {
  N: 'None',
  BMF: 'British Motorcycle Federation (BMF)',
  BMO: 'British Motorcycle Owners Club',
  IAM: 'Institue of Advanced Motorists',
  MAG: 'Motorcycle Action Group (MAG)',
  NABD: 'National Association for Bikers with a Disability',
  NSRA: 'National Scooter Riders Association',
  YBMO: 'Your Bike Manufacturers Owners Club',
  VJM: 'Vintage Japanese Motorcycle Club',
  VM: 'Vintage Motorcycle Club',
  WIM: 'Womens International Motorcycle Association',
};

export const COVER_TYPE_OF_COVER = {
  1: 'Comprehensive',
  2: 'Third Party, Fire & Theft',
  3: 'Third Party Only',
};

export const COVER_TYPE_OF_COVER_DESCRIPTION = {
  1: 'Cover provided if your car’s damaged, stolen or written off. You’ll be covered for claims made against you by other people too',
  2: 'If your car’s stolen, or damaged by fire, you can claim. You’re also covered for claims made against you by other people',
  3: 'Cover for claims made against you by other people but there’s no cover for you or your car',
};

export const COVER_NO_CLAIMS_BONUS = {
  0: 'No NCD',
  1: '1 Year',
  2: '2 Years',
  3: '3 Years',
  4: '4 Years',
  5: '5 Years',
  6: '6 Years',
  7: '7 Years',
  8: '8 Years',
  9: '9 Years',
  10: '10 Years',
  11: '11 Years',
  12: '12 Years',
  13: '13 Years',
  14: '14 Years',
  15: '15 Years',
  16: '16 Years',
  17: '17 Years',
  18: '18 Years',
  19: '19 Years',
  20: '20 Years or more',
};
export const COVER_NO_CLAIMS_BONUS_MAX = Math.max(...Object.keys(COVER_NO_CLAIMS_BONUS));
export const COVER_NO_CLAIMS_BONUS_MIN = Math.min(...Object.keys(COVER_NO_CLAIMS_BONUS));

export const COVER_VOLUNTARY_EXCESS = {
  0: 'None',
  50: '£ 50',
  100: '£ 100',
  150: '£ 150',
  200: '£ 200',
  250: '£ 250',
  300: '£ 300',
  350: '£ 350',
  400: '£ 400',
  450: '£ 450',
  500: '£ 500',
};

export const COVER_OWNER_OF_VEHICLE = {
  1: 'You (Policyholder)',
  2: 'Spouse',
  3: 'Parents',
  4: 'Company',
  5: 'Privately Leased',
  7: 'Common Law Partner',
  8: 'Civil Partner',
  9: 'Society or Club',
  6: 'Other',
};

export const COVER_REGISTERED_OF_VEHICLE = {
  1: 'You (Policyholder)',
  2: 'Spouse',
  3: 'Parents',
  4: 'Company',
  5: 'Privately Leased',
  7: 'Common Law Partner',
  8: 'Civil Partner',
  9: 'Society or Club',
  6: 'Other',
};

export const COVER_FREE_DRIVING = {
  0: 'Less than a year',
  1: '1 Year',
  2: '2 Years',
  3: '3 Years',
  4: '4 Years',
  5: '5 Years or more',
};

export const VEHICLE_REG_TYPES = {
  van: 'GV',
  taxi: 'TX',
  bike: 'MC',
  car: 'PC',
};

export const DRIVER_CONVICTION_POINTS_RECEIVED = {
  0: '0 Points',
  1: '1 Point',
  2: '2 Points',
  3: '3 Points',
  4: '4 Points',
  5: '5 Points',
  6: '6 Points',
  7: '7 Points',
  8: '8 Points',
  9: '9 Points',
  10: '10 Points',
  11: '11 Points',
  12: '12 Points',
};

export const VEHICLE_FUEL_TYPES = {
  P: 'Petrol',
  D: 'Diesel',
  E: 'Electric',
  H: 'Hydrogen',
  B: 'Biofuel',
  C: 'CNG',
};

export const LICENCE_OBTAIN_MIN_AGE = 17;
export const PROVISIONAL_LICENCE_OBTAIN_MIN_AGE = 16;

export const BODY_CLASS_TYPES = {
  car: 'CAR',
  bike: 'BIKE',
  van: 'VAN',
  taxi: 'TAXI',
};

export const CLAIMS_MAX_QTY = 5;
export const CONVICTIONS_MAX_QTY = 5;
export const INCIDENT_MAX_YEARS = 5;
export const DRIVERS_MAX_QTY = 5;
export const DATE_OF_INSURANCE_START_MAX_DAYS = 30;
export const INSURER_MAX_AGE = 105;
export const INSURER_MIN_AGE = 16;

export const VEHICLE_SYSTEM_TYPES = {
  car: 1,
  van: 2,
  bike: 5,
  taxi: 18,
};

export const OPTIONAL_EXTRAS_OPTIONS = [
  {
    value: 'legal',
    trackerValue: 'legalAssistance',
    label: 'Legal Assistance',
  },
  {
    value: 'helmet',
    trackerValue: 'helmetAndLeathers',
    label: 'Helmet & Leathers',
    infoLabel: 'Helmet and Leathers',
  },
  {
    value: 'accident',
    trackerValue: 'personalAccident',
    label: 'Personal Accident',
  },
  {
    value: 'breakdown',
    trackerValue: 'breakdownCover',
    label: 'Breakdown Cover',
  },
];

export const OPTIONAL_EXTRAS_TRACKER_OPTIONS = createTrackerOptions(OPTIONAL_EXTRAS_OPTIONS);

export const PASSWORD_MIN = 6;
export const PASSWORD_MAX = 20;

export const QUOTE_LIMIT_DATA_DEFAULT = '<p>You have exceeded your quote limit.</p><p>Please review your emails for details on how to retrieve your personal quote details.</p><p>Alternatively email us at <a href="mailto:info@seopa.com">info@seopa.com</a></p>';
export const QUOTE_LIMIT_ACTION_DEFAULT = 'modal';
